var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colorable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.586,30L20,49.414l29-29V1H29.586L0.586,30z M47,3v16.586l-27,27L3.414,30l27-27H47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,14c2.206,0,4-1.794,4-4s-1.794-4-4-4s-4,1.794-4,4S37.794,14,40,14z M40,8c1.103,0,2,0.897,2,2s-0.897,2-2,2 s-2-0.897-2-2S38.897,8,40,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelTag);
export default __webpack_public_path__ + "static/media/left-panel-tag.c7b1f87ee4ae6e4435f454c24d1c7ad4.svg";
export { ForwardRef as ReactComponent };